<template>
  <div class="modal fade" id="addStudentModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Student</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-left">
          <label v-if="errorMessage != ''" class="text-danger">{{
            errorMessage
          }}</label>
          <transition
            v-if="schools.length > 0 && services.length > 0"
            name="slide-fade"
            mode="out-in"
          >
            <form key="name" @submit.prevent="createNewStudent">
              <div class="form-group">
                <label for="name"> Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="Name"
                  v-model="newStudentName"
                  required
                />
              </div>
              <div class="form-group">
                <label for="grade">Grade</label>
                <select
                  id="grade"
                  name="gradePicker"
                  class="form-control selectpicker"
                  data-style="btn-outline-primary"
                  data-none-selected-text="Select Grade..."
                  data-actions-box="true"
                  v-model="newStudentGrade"
                  required
                >
                  <option value="Pre-K">Pre-K</option>
                  <option value="Kindergarten">Kindergarten</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="Post-High">Post-High</option>
                  <option value="In-Home">In-Home</option>
                </select>
              </div>
              <div class="form-group">
                <label>Services</label>
                <br/>
                <select class="selectpicker" data-width="100%" multiple v-model="newStudentServices" required>
                  <option v-for="service in services" v-bind:key="service.id" v-bind:value="service">{{ service.get("name") }}</option>
                </select>
              </div>
              <label v-if="newStudentServices.length > 0">Service Minutes</label>
              <div v-for="service in newStudentServices" v-bind:key="service.id" class="form-group">
                <div class="row">
                  <div class="col">
                    <label>{{ service.get("name") }}</label>
                  </div>
                  <div class="col">
                    <div class="form-check">
                      <input class="form-check-input" v-model="serviceRecordingPeriod[service.id]" type="radio" v-bind:name="service.id + 'radios'" value="weekly" v-bind:id="service.id + 'WeekCheck'">
                      <label class="form-check-label" v-bind:for="service.id + 'WeekCheck'">
                        Weekly
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" v-model="serviceRecordingPeriod[service.id]" type="radio" v-bind:name="service.id + 'radios'" value="monthly" v-bind:id="service.id + 'MonthCheck'">
                      <label class="form-check-label" v-bind:for="service.id + 'MonthCheck'">
                        Monthly
                      </label>
                    </div>
                  </div>
                  <div class="col-auto">
                    <input
                      type="number"
                      class="form-control"
                      id="serviceMinutes"
                      placeholder="IEP defined minutes"
                      v-model="serviceMinutes[service.id]"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="school">School/Organization</label>
                <select
                    id="school"
                    name="schoolPicker"
                    class="form-control selectpicker"
                    data-style="btn-outline-primary"
                    data-none-selected-text="Select School/Organization..."
                    data-actions-box="true"
                    v-model="newStudentSchool"
                    required
                  >
                  <option v-for="school in schools
                    .slice()
                    .sort($orderByParseName)"
                    :key="school.id + 'school'"
                    v-bind:value="school"
                    >{{school.get("name")}}</option>
                </select>
              </div>
              <div class="text-right">
                <button type="submit" class="btn btn-primary">
                  Create Student
                </button>
              </div>
            </form>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Parse from "parse";

export default {
  name: "AddStudentModal",
  props: {
    Schools: Array,
    Services: Array
  },
  data() {
    return {
      newStudentName: "",
      schools: this.Schools,
      services: this.Services,
      newStudentSchool: [],
      newStudentGrade: null,
      newStudentServices:  [],
      serviceRecordingPeriod: [],
      serviceMinutes: [],
      errorMessage: ""
    };
  },
  watch: {
    Schools: function() {
      this.schools = this.Schools;
    },
    Services: function() {
      this.services =  this.Services
    }
  },
  mounted() {
    $("#addStudentModal").on("shown.bs.modal", function() {
      $("#name").focus();
      $(".selectpicker").selectpicker("refresh");
    });
  },
  methods: {
    async submitNewStudent() {
      await this.createStudent();
    },
    async createNewStudent() {
      $("#addStudentModal").modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);

      var studentToCreate = new Parse.Object("Student");
      studentToCreate.set("name", view.newStudentName);
      studentToCreate.set("grade", view.newStudentGrade);
      studentToCreate.set("schoolName", view.newStudentSchool.get("name"));
      var studentServices = []
      this.newStudentServices.forEach(service => {
        var incomingService = {"service": service.id, "period": view.serviceRecordingPeriod[service.id], "minutes": view.serviceMinutes[service.id]}
        console.log(incomingService)
        studentServices.push(incomingService)
      });
      studentToCreate.set("services", studentServices)

      var acl = new Parse.ACL(Parse.User.current())
      acl.setRoleReadAccess(view.newStudentSchool.get("name"), true);
      acl.setRoleWriteAccess(view.newStudentSchool.get("name"), true);

      studentToCreate.setACL(acl);
      studentToCreate.save()
      .then((newStudent) => {
        view.clearFields();
        view.$emit("student-added");
        console.log(newStudent);
        view.$store.commit("updateLoading", false);
      }, (error) => {
        this.errorMessage = error.message;
        $("#addStudentModal").modal("show");
        view.$store.commit("updateLoading", false);
      });
    },
    clearFields() {
      this.newStudentName = "";
      this.newStudentSchool = null;
      this.newStudentServices = [];
      this.serviceRecordingPeriod = [];
      this.serviceMinutes = [];
      this.newStudentGrade = null;
      this.errorMessage = ""
    }
  }
};
</script>
